import PropTypes from 'prop-types';
import Pagination from '@mui/material/Pagination';
import { useErrorBoundary } from 'react-error-boundary';
import { cardsPerPage } from '../../utils/miscConstants';
import { sendDataToAnalytics } from '../../utils/misFunctions';
import { useHealthyDealsDataContext } from '../HealthyDealsDataContextProvider/HealthyDealsData.context';

const DealsGridPagination = ({
	dealsTotalCount = 0,
	loading = false,
	setSkipData = () => null,
}) => {
	const {
		selectedCategorySavedInContext,
		topHeadingElementRef,
		paginationPageFromContext,
		setPaginationPageFromContext,
	} = useHealthyDealsDataContext();
	const { showBoundary } = useErrorBoundary();

	const handleChangePage = (event, newPage) => {
		event.preventDefault();
		try {
			topHeadingElementRef?.current?.scrollIntoView(true);

			sendDataToAnalytics({
				eventName: 'paginationClick',
				eventData: {
					dealCategory: selectedCategorySavedInContext?.label || null,
				},
			});
			setPaginationPageFromContext(newPage);
			setSkipData((newPage - 1) * cardsPerPage);
		} catch (error) {
			showBoundary(error);
		}
	};
	return (
		!loading &&
		dealsTotalCount > cardsPerPage && (
			<Pagination
				count={Math.ceil(dealsTotalCount / cardsPerPage)}
				page={paginationPageFromContext}
				size="large"
				onChange={handleChangePage}
			/>
		)
	);
};

DealsGridPagination.propTypes = {
	dealsTotalCount: PropTypes.number,
	setSkipData: PropTypes.func,
	loading: PropTypes.bool,
};

export default DealsGridPagination;
